import { render, staticRenderFns } from "./SpecFilm.vue?vue&type=template&id=34f611ae&"
import script from "./SpecFilm.vue?vue&type=script&lang=js&"
export * from "./SpecFilm.vue?vue&type=script&lang=js&"
import style0 from "./SpecFilm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports